import { render, staticRenderFns } from "./CountBadge.vue?vue&type=template&id=5c22f2d2&scoped=true"
import script from "./CountBadge.vue?vue&type=script&lang=ts"
export * from "./CountBadge.vue?vue&type=script&lang=ts"
import style0 from "./CountBadge.vue?vue&type=style&index=0&id=5c22f2d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22f2d2",
  null
  
)

export default component.exports